import { render, staticRenderFns } from "./radish.vue?vue&type=template&id=25283c2e"
import script from "./radish.vue?vue&type=script&lang=js"
export * from "./radish.vue?vue&type=script&lang=js"
import style0 from "./radish.vue?vue&type=style&index=0&id=25283c2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports